const VERSION = '4.1.0';
export default VERSION;
